import { AxiosError } from 'axios';
import Toast from 'react-native-toast-message';
import { i18n } from 'app/localization/i18n';

export const MAX_UPLOAD_FILE_SIZE_BYTES = 20 * 1024 * 1024;
export const MAX_UPLOAD_FILE_SIZE_MB = Math.round(MAX_UPLOAD_FILE_SIZE_BYTES / (1024 * 1024));

function getErrorMessage(error: unknown): string {
  if (!(error instanceof AxiosError)) return '';
  const data = error.response?.data as { message?: unknown } | undefined;
  if (typeof data?.message === 'string') return data.message;
  return typeof error.message === 'string' ? error.message : '';
}

export function isFileTooLargeError(error: unknown): boolean {
  if (!(error instanceof AxiosError)) return false;
  const status = error.response?.status;
  const message = getErrorMessage(error);
  return (status === 400 || status === 413 || status === 422) && /expected size is less than/i.test(message);
}

export function extractMaxUploadSizeMb(error: unknown): number {
  const message = getErrorMessage(error);
  const match = /expected size is less than\s+(\d+)/i.exec(message);
  const bytes = match ? Number(match[1]) : NaN;
  if (!Number.isFinite(bytes) || bytes <= 0) return MAX_UPLOAD_FILE_SIZE_MB;
  return Math.max(1, Math.round(bytes / (1024 * 1024)));
}

export function fileTooLargeMessage(error?: unknown): string {
  return i18n.t('fileTooLarge.text', { ns: 'image-picker', max: extractMaxUploadSizeMb(error) });
}

export function showFileTooLargeToastIfNeeded(error: unknown): boolean {
  if (!isFileTooLargeError(error)) return false;
  Toast.show({
    type: 'error',
    text1: i18n.t('fileTooLarge.title', { ns: 'image-picker' }),
    text2: fileTooLargeMessage(error),
    position: 'bottom',
    bottomOffset: 100,
    visibilityTime: 15000,
  });
  return true;
}
